import cn from 'classnames';
import React from 'react';

import * as localizationKeys from '../../../consts/localization/localizationKeys';
import useDeviceTypeStyles from '../../../hooks/useDeviceTypeStyles';
import {getLocalizedStrings} from '../../../services/localization/localizationService';

const UpdateFWPageTemplate = (props) => {
    const {current, total, children, titleKey, isCountVisible = true, rightSectionChildren} = props;
    const localizedStrings = getLocalizedStrings();
    const countMessage = localizedStrings.formatString(
        localizedStrings[localizationKeys.FIRMWARE_INSTALL_COUNT],
        current,
        total
    );
    const title = localizedStrings.formatString(localizedStrings[titleKey], current, total);
    const deviceTypeClassNames = useDeviceTypeStyles();

    return (
        <div className='m-auto w-full xl:max-w-[1480px]'>
            <div className='flex flex-col lg:my-[88px] lg:grid lg:flex-none lg:grid-cols-12'>
                {isCountVisible && <div className='body-14 py-[18px] lg:hidden'>{countMessage}</div>}
                <div
                    className={`
                                order-3 mx-8 flex flex-col items-center pb-8
                                lg:order-1 lg:col-span-3 lg:col-start-2 lg:mx-0 lg:items-start lg:justify-center lg:pb-0 lg:ltr:text-left lg:rtl:text-right
                `}
                >
                    {isCountVisible && <div className='body-14 hidden lg:block'>{countMessage}</div>}
                    <div className='flex max-w-[536px] flex-col items-center lg:items-start'>
                        <h1 className='mb-5 mt-8 lg:mt-4'>{title}</h1>
                        {children}
                    </div>
                </div>
                <div
                    className={cn(
                        'relative order-2 flex h-[210px] items-center justify-center lg:col-span-6 lg:col-start-6 lg:h-[428px]',
                        deviceTypeClassNames
                    )}
                >
                    {rightSectionChildren}
                </div>
            </div>
        </div>
    );
};

export default UpdateFWPageTemplate;
